module.exports = __webpack_public_path__ + "img/center-2018-poverty-image.75c20526.jpg";